<template>
  <b-modal
    :id="id"
    :title="`${isEdit ? `Editar Cuenta - ${form.code}` : 'Añadir courier y Nueva cuenta' }`"
    ok-variant="warning"
    modal-class="dialog-900 modal-background--multi-color"
    ok-only
    @show="onShow"
    @close="onClose"
  >
    <div>
      <ul v-if="!isEdit">
        <li>Por favor, proporcione información detallada del courier y la cuenta a crear.</li>
      </ul>
      <div v-else class="custom-switch mt-1 mb-2 d-flex">
          <div>
            <b-form-checkbox
            id="is_active"
            v-model="activeAccout"
            @change="onChangeSwitch"
            :key="keyActiveSwitch"
            switch>
            </b-form-checkbox>
          </div>
          <div :key="keyAccountStatus">
            <span class="font-weight-bold">{{ activeAccout ? 'Cuenta Activa' : 'Cuenta Inactiva' }}</span>
            <span class=""><small>&nbsp;{{ activeAccout ? '(Al inactivar la vinculación MeliFlex, la regla asociada dejará de funcionar).' : '(Al activar la vinculación MeliFlex, se restablecerá el funcionamiento de la regla asociada).'}}</small></span>
          </div>
        </div>
      <form-render
        :fields="fields"
        :form="form"
        :key="keyFormRenderMeli"
        ref="formRenderDetailMeliMeli"
        containerButtonsClass="col-sm-12 col-lg-4 container-button"
      />
      <b-alert
        class="custom-alert col-sm-12 col-md-12 col-lg-12 px-1 special-warning mt-2"
        variant="warning"
        show
        v-if="isEdit"
      >
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0 mr-2">
            <feather-icon size="25" icon="AlertTriangleIcon" class="text-warning"/>
          </div>
          <div class="flex-grow-1">
            <span class="mb-0">
              Es importante tener en consideración que cualquier cambio en la configuración de la cuenta podría afectar la operación actual.
              <br/>
              Si se requiere una configuración diferente, se recomienda crear una nueva cuenta para evitar interrupciones.
            </span>
          </div>
        </div>
      </b-alert>
    </div>
    <template #modal-footer>
      <b-button variant="warning" @click.prevent="ok()" :disabled="loading || Object.values(form).length <= 3">
        <b-spinner v-show="loading" small></b-spinner>
        {{$t('Guardar')}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'modal-meliflex-account',
  props: ['id', 'accountID'],
  data() {
    return {
      isEdit: false,
      form: {},
      fields: [],
      keyFormRenderMeli: 0,
      keyAccountStatus: 0,
      keyActiveSwitch: 0,
      loading: false,
      services: [],
      initalForm: null,
      activeAccout: false
    }
  },
  computed: {
    ...mapGetters({
      meliFlexCarriers: 'getMeliFlexCarriers',
      accountFlexById: 'getAccountFlexById'
    })
  },
  watch: {
    meliFlexCarriers(val) {
      const rawCarriers = val?.carriers || []
      const carriers = rawCarriers.map(carrier => {
        const services = (carrier.services || []).map(service => ({
          ...service,
          text: service.name
        }))
        return {
          ...carrier,
          text: `[${carrier?.code}] ${carrier?.name}`,
          services
        }
      })
      if (!this.isEdit) {
        this.setOptions('carrier', carriers)
        this.useSkeleton('carrier', false)
      }
    },
    accountID(val) {
      this.isEdit = !!val
      if (!val) return
      const data = {
        name: 'getAccountFlexById',
        params: { account_id: val }
      }
      this.$store.dispatch('fetchService', data)
    },
    accountFlexById(accountData) {
      this.form = {
        ...accountData,
        account_name: accountData.name,
        shipping_method: 'MeliFlex',
        carrier: `[${accountData?.carrier_code?.toUpperCase()}] ${accountData.carrier_name}`,
        service: accountData.carrier_service?.name
      }
      this.activeAccout = this.form.is_active
    }
  },
  methods: {
    setInitialData() {
      this.fields = [
        { fieldType: 'FieldInput', name: 'account_name', label: 'Nombre de cuenta', containerClass: 'col-md-6 mt-1 col-sm-12', validation: 'required', clearable: true },
        { fieldType: 'FieldInput', name: 'shipping_method', label: 'Modalidad de envío', containerClass: 'col-md-6 mt-1 col-sm-12', disabled: true },
        { fieldType: 'FieldSelect', name: 'carrier', label: 'Courier', containerClass: 'col-sm-12 col-md-6 mt-1 container-info', validation: 'required', change: this.onChangeCarrier, useSkeleton: !this.isEdit, useLabel: true, disabled: this.isEdit, clearable: !this.isEdit },
        { fieldType: 'FieldSelect', name: 'service', label: 'Servicio', containerClass: 'col-sm-12 col-md-6 mt-1 container-info', validation: 'required', dependency: 'carrier', disabled: this.isEdit, clearable: !this.isEdit }
      ]
      if (!this.isEdit) {
        this.form = { shipping_method: 'MeliFlex' }
        this.getMeliflexData()
      }
    },
    getMeliflexData() {
      const data = {
        name: 'getMeliFlexCarriers',
        params: {shipper_id: this.$route.params.id }
      }
      this.$store.dispatch('fetchService', data)
    },
    onChangeSwitch(checked) {
      this.activeAccout  = checked
      this.keyAccountStatus++
    },
    onChangeCarrier(_, value) {
      delete this.form.service
      if (!value) {
        delete this.form.carrier
        this.setOptions('service', [])
        return
      }
      this.setOptions('service', value.services)
    },
    onChangeServices(_, value) {
      if (!value) {
        delete this.form.service
      }
    },
    setOptions(name, data) {
      const index = this.m_getElementIndex(this.fields, 'name', name)
      if (index === -1) return
      this.fields[index].options = data
      this.keyFormRenderMeli++
    },
    useSkeleton(name, data) {
      const index = this.m_getElementIndex(this.fields, 'name', name)
      if (index === -1) return
      this.fields[index].useSkeleton = data
    },
    createAccount() {
      const queryParams = {
        shipper_id: this.$route.params.id,
        carrier_code: this.form.carrier.code,
        carrier_service_id: this.form?.service?.id,
        name: this.form.account_name,
        code: this.meliFlexCarriers?.shipper?.code,
        parent_id: 10,
        delivery_mode: 'meliflex',
        contract_type: 'enviaflex',
        is_active: true,
        customization: {}
      }
      this.$store.dispatch('fetchService', {
        name: 'postAccountFlex',
        queryParams,
        hideAlert: true,
        onSuccess: () => this.succesAction(queryParams.code),
        onError: (err) => {
          this.loading = false
          this.$bvModal.hide(this.id)
          this.$newError('¡La vinculación MeliFlex no se ha completado con éxito!', 'Inténtalo de nuevo. Si el inconveniente persiste, contacta a nuestro equipo de Support para obtener más información.', 'xlarge')
        }
      })
    },
    updateAccount() {
      const queryParams = {
        name: this.form.account_name,
        code: this.form.code,
        parent_id: 10,
        shipper_id: Number(this.$route.params.id),
        carrier_code: this.form.carrier_code,
        delivery_mode: 'meliflex',
        contract_type: 'enviaflex',
        is_active: this.activeAccout,
        carrier_service_id: this.form.carrier_service_id,
        customization: {}
      }
      this.$store.dispatch('fetchService', {
        name: 'putAccountFlex',
        params: { account_id: this.accountID },
        queryParams,
        hideAlert: true,
        onSuccess: () => this.succesAction(queryParams.code),
        onError: (err) => {
          this.loading = false
          this.onClose()
          this.$bvModal.hide(this.id)
          this.$newError('¡No pudimos guardar los cambios!', 'Inténtalo de nuevo. Si el inconveniente persiste, contacta a nuestro equipo de Support para obtener más información.', 'xlarge')
        }
      })
    },
    succesAction(code) {
      this.$newSuccess(
        this.isEdit ? '¡Los cambios se guardaron con éxito!' : '¡La vinculación MeliFlex se ha completado con éxito!',
        this.isEdit ? `Actualizamos la cuenta ${code} y ya puedes ver los cambios reflejados en la plataforma.` : `Hemos creado la cuenta ${code} para que puedas comenzar a optimizar tus operaciones.`, 'large'
      )
      this.loading = false
      this.$emit('refreshAccounts')
      this.$bvModal.hide(this.id)
    },
    onShow() {
      this.setInitialData()
    },
    ok() {
      this.loading = true
      this.isEdit ? this.updateAccount() : this.createAccount()
    },
    onClose() {
      this.form = {
        shipping_method: 'MeliFlex'
      }
      if (this.accountID) this.$emit('refreshID')
      this.$emit('clearBtn')
    }
  }
}
</script>

<style lang="scss">
div.modal-background--multi-color .modal-content .modal-body div.special-warning {
  background-color: #fff7e7 !important;
  padding-top: 5px;
  padding-bottom: 5px;
  span {
    color: #5C5C5C;
    font-size: 0.8rem;
  }
}
</style>